import { createSelector } from 'reselect'
import moment from 'moment'
import { formatCurrency } from '../utils/utils'
export const CDN = process.env.REACT_APP_IMG_URL_SOURCE

//TODO: SAVE MEALS_ID(0) SIDES_ID(13) TO CONSTANTS FILE

const formatUpcomingDay = t => ({
  ...t,
  label: moment(t.displayDate).format('dddd, MMMM D'),
  value: t.date
})

const formatTimeslot = t => ({ ...t, value: { start: t.start, end: t.end } })

const formatMeals = meal => ({
  ...meal,
  chefImage: `${CDN}${meal.logopic}`,
  mealImage: `${CDN}${meal.image_path}${(meal.image || '').substr(1)}`,
  chefName: `${meal.chef_firstname} ${meal.chef_lastname}`,
  formattedPrice: formatCurrency(meal.price),
  mealFullName: [
    meal.name.trim(),
    ...[meal.short_description ? meal.short_description.trim() : '']
  ].join(' ')
})

export const getDeliveryDays = createSelector(
  state => state.publicData.upcomingDays.data,
  upcomingDays => upcomingDays.filter(d => d.available).map(formatUpcomingDay)
)

export const getDeliveryTimes = createSelector(
  state => state.publicData.timeslots.data,
  timeslots => timeslots.map(formatTimeslot)
)

export const getMenu = createSelector(
  state => state.publicData.menu.data,
  data => {
    if (data && data.available && data.categories) {
      const categories = data.categories.map(category => {
        const meals = category.meals

        return {
          ...category,
          meals: meals.map(formatMeals)
        }
      })

      return categories
    }
    return []
  }
)

export const getCurrentCategories = createSelector(
  state => state.publicData.availableCategories,
  categories => categories
)

export const getSelectedCategoryId = createSelector(
  state => state.publicData.selectedCategoryId,
  id => id
)

export const deliveryTimesLoading = createSelector(
  state => state.publicData.timeslots.loading,
  loading => loading
)

export const deliveryDaysLoading = createSelector(
  state => state.publicData.upcomingDays.loading,
  loading => loading
)

export const menuLoading = createSelector(
  state => state.publicData.menu.loading,
  loading => loading
)

export const deliveryTimesCached = createSelector(
  state => state.publicData.timeslots.success,
  success => success
)

export const deliveryDaysCached = createSelector(
  state => state.publicData.upcomingDays.success,
  success => success
)



// WEBPACK FOOTER //
// ./src/selectors/public.js